import { Button } from '@/components/common/Button';
import { DialogWrapper } from '@/components/common/DialogWrapper';
import { RelationActionButton } from '@/components/common/RelationActionButton';
import type { Item } from '@/domain/Item';

export interface DeleteIngredientDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  supplement: Item | null;
  onConfirm: (supplementId: number) => void;
  isPending?: boolean;
}

export function DeleteIngredientDialog({
  open,
  onOpenChange,
  supplement,
  onConfirm,
  isPending,
}: DeleteIngredientDialogProps) {
  if (!supplement) return null;

  const handleConfirm = () => {
    onConfirm(supplement.id);
  };

  return (
    <DialogWrapper
      open={open}
      onOpenChange={onOpenChange}
      title="Delete Supplement"
      maxWidth="md"
    >
      <div className="mt-4 flex flex-col gap-6">
        <p className="text-base">
          Are you sure you want to delete{' '}
          <span className="font-semibold">{supplement.name}</span>?
        </p>
        <p className="text-muted-foreground text-sm">
          This action cannot be undone.
        </p>

        <div className="flex items-center justify-between gap-4">
          <Button
            type="button"
            variant="destructive"
            size="sm"
            onClick={handleConfirm}
            disabled={isPending}
          >
            {isPending ? 'Deleting...' : 'Delete'}
          </Button>
          <RelationActionButton
            type="button"
            onClick={() => onOpenChange(false)}
          >
            Cancel
          </RelationActionButton>
        </div>
      </div>
    </DialogWrapper>
  );
}
